import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { BenchmarkResultEdit } from './components/benchmark-result-edit';

type BenchmarkResultEditForm = {
    result: string;
    cpuName: string;
    cpuFrequency: string;
    cpuBusFrequency: string;
    cpuVoltage: string;
    cpuTemperature: string;
    cpuIsEngineeringSample: boolean;
    cpuUnlockedCores: string;
    cpuCount: string;
    memorySize: string;
    memoryModules: string;
    memoryFrequency: string;
    memoryTimings: string;
    memoryType: string;
    gpuName: string;
    gpuCount: string;
    motherboardName: string;
    motherboardVendor: string;
    motherboardBios: string;
    osName: string;
    osVersion: string;
    validationUrl: string;
    benchmarkTime: string;
    removeScreenshot: boolean;
};

type EditBenchmarkResultPage = {
    heading: string;
    backUrl: string;
    viewUrl: string;
    postUrl: string;
    cpuLookupUrl: string;
    gpuLookupUrl: string;
    antiForgeryToken: string;
    hasScreenshot: boolean;
    errorMessage?: string | null;
    form: BenchmarkResultEditForm;
};

function initializeBenchmarkResultEdit(): void {
    const rootElement = document.getElementById('benchmark-result-edit-root');
    if (!(rootElement instanceof HTMLElement)) {
        return;
    }

    const pageData = rootElement.dataset.page;
    if (typeof pageData !== 'string' || pageData.length === 0) {
        return;
    }

    const page = JSON.parse(pageData) as EditBenchmarkResultPage;
    createRoot(rootElement).render(<BenchmarkResultEdit page={page} />);
}

initializeBenchmarkResultEdit();
